import ContainerOpRoutes from "./container_op";

export default [
    ...ContainerOpRoutes,
];
